import { Badge } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type KmContextAttributeTitleProps = {
  name: string;
  /** Атрибут назначен на уровне и уже приходит сверху */
  isRepeat?: boolean;
};

/** Название атрибута контекста оценки с отметкой повтора */
export const KmContextAttributeTitle: FC<KmContextAttributeTitleProps> = ({ name, isRepeat = false }) => {
  const { t } = useTranslation('expertReport');

  return (
    <span className="inline-flex min-w-0 flex-wrap items-center gap-2">
      <span className="min-w-0">{name}</span>
      {isRepeat && (
        <Badge variant="secondary" outline className="shrink-0">
          {t('km.contextRepeat')}
        </Badge>
      )}
    </span>
  );
};
